<app-page-header title="function.Roles" translateTitle="yes" icon="assignment_ind"></app-page-header>
<div [@fadeInOut] class="page-content">

  <div class="flex-row gap-col-1em">
    <mat-form-field class="flex-1">
      <mat-label>{{'globalTexts.SearchInstruction' | translate}}</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)">
    </mat-form-field>
  </div>

  <div class="example-container mat-elevation-z8">
    @if (loadingIndicator) {
      <mat-progress-bar mode="query"></mat-progress-bar>
    }
    <mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="name">
        <mat-header-cell class="flex-grow40" *matHeaderCellDef mat-sort-header> {{'roles.management.Name' | translate}} </mat-header-cell>
        <mat-cell class="flex-grow40" *matCellDef="let role"> {{role.name}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef mat-sort-header> {{'roles.management.Description' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let role"> {{role.description}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="users">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="flex-100px"> {{'roles.management.Users' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let role" class="flex-100px"> {{role.usersCount}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef class="flex-140px">
        </mat-header-cell>
        <mat-cell *matCellDef="let role"class="flex-140px">
          @if (!canManageRoles) {
            <button mat-icon-button matTooltip="{{'roles.management.Details' | translate}}" (click)="editRole(role)">
              <mat-icon>more_vert</mat-icon>
            </button>
          }
          @if (canManageRoles) {
            <button mat-icon-button matTooltip="{{'roles.management.Edit' | translate}}" (click)="editRole(role)">
              <mat-icon>edit</mat-icon>
            </button>
          }
          @if (canManageRoles) {
            <button mat-icon-button matTooltip="{{'roles.management.Delete' | translate}}" (click)="confirmDelete(role)">
              <mat-icon color="warn">delete</mat-icon>
            </button>
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;">
      </mat-row>
    </mat-table>

    <mat-paginator hidePageSize="true" pageSize="50" [pageSizeOptions]="[5, 10, 25, 100]" class="customPaginator"></mat-paginator>

    @if (canManageRoles) {
      <section class="button-container">
        <button mat-fab color="primary" matTooltip="{{'commands.Add' | translate}}" (click)="editRole()"><mat-icon>add</mat-icon></button>
      </section>
    }

  </div>
</div>





